export type IHotelInfoRouteParamName = "hotelId";
export const hotelInfoRouteParamNames: SameRecord<IHotelInfoRouteParamName> = {
  hotelId: "hotelId",
};
export const HOTEL_INFO_ROUTE_PATH = `/hotels/:${hotelInfoRouteParamNames.hotelId}`;
